import '../stylesheets/styles.scss';

import 'core-js';

import 'bootstrap-italia';
// import 'select2';

import './utils/imagesConfig';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/respimg/ls.respimg';

import 'slick-carousel';

import { PageData, Cookies, Keyboard, Logger, Responsive } from './utils'; // eslint-disable-line object-curly-newline
import { asyncSVG } from './libs/asyncSVG';
import { Header } from './components/header';
import { Footer } from './components/footer';
import { CookiePreferences } from './components/cookie-preferences';
import { ThirdPartyEmbeds } from './components/third-party-embeds';
import { Page } from './components/page';
import { Intestazione } from './components/intestazione';
import { Card } from './components/card';
import { CardList } from './components/card-list';
import { RichText } from './components/richt-text';
import { MainSection } from './components/main-section';
import { SharingIcons } from './components/sharing-icons';
import { SearchResult } from './components/search-result';
import { PrimoPiano } from './components/primo-piano';
import { Rubriche } from './components/rubriche';
import { SearchModal } from './components/search-modal';
import { SearchInput } from './components/search-input';
import { ElencoArticoli } from './components/elenco-articoli';
import { AvvisoSezione } from './components/avviso-sezione';
import { RisultatoRicerca } from './components/risultato-ricerca';
import { DettaglioArticolo } from './components/dettaglio-articolo';
import { DettaglioRubriche } from './components/dettaglio-rubriche';
import { Pagination } from './components/pagination';
import { Breadcrumbs } from './components/breadcrumbs';
import { NotizieCorrelate } from './components/notizie-correlate';
import { SearchRecap } from './components/search-recap';
import { FilterModal } from './components/filter-modal';
import { FilterButton } from './components/filter-button';
import { FilterForm } from './components/filter-form';
import { Filters } from './components/filters';
import { CardListGallery } from './components/card-list-gallery';
import { ArticleMediaImg } from './components/article-media-img';
import { ArticleMediaSlider } from './components/article-media-slider';
import { ArticleHeader } from './components/article-header';
import { ArticleDescription } from './components/article-description';
import { ArticleMediaVideo } from './components/article-media-video';
import { ArticleSocial } from './components/article-social';
import { ScrollIcon } from './components/scroll-icon';
import { ArticleAttachments } from './components/article-attachments';

if (!('object-fit' in document.createElement('a').style)) {
  require('lazysizes/plugins/object-fit/ls.object-fit'); // eslint-disable-line global-require
}

document.addEventListener('DOMContentLoaded', () => {
  // anche se non chiami init, questo garantisce che bootstrap-italia sia incluso
});

// load asyncronously the SVG sprite and inject it inside the page
asyncSVG();

// initialize components
const Components = {
  header: new Header(),
  footer: new Footer(),
  cookiePreferences: new CookiePreferences(),
  thirdPartyEmbeds: new ThirdPartyEmbeds(),
  intestazione: new Intestazione(),
  card: new Card(),
  cardList: new CardList(),
  richText: new RichText(),
  mainSection: new MainSection(),
  sharingIcons: new SharingIcons(),
  searchResult: new SearchResult(),
  primoPiano: new PrimoPiano(),
  rubriche: new Rubriche(),
  searchModal: new SearchModal(),
  searchInput: new SearchInput(),
  risultatoRicerca: new RisultatoRicerca(),
  elencoArticoli: new ElencoArticoli(),
  avvisoSezione: new AvvisoSezione(),
  dettaglioArticolo: new DettaglioArticolo(),
  dettaglioRubriche: new DettaglioRubriche(),
  pagination: new Pagination(),
  breadcrumbs: new Breadcrumbs(),
  notizieCorrelate: new NotizieCorrelate(),
  searchRecap: new SearchRecap(),
  filterModal: new FilterModal(),
  filterButton: new FilterButton(),
  filterForm: new FilterForm(),
  SearchRecap: new SearchRecap(),
  Filters: new Filters(),
  cardListGallery: new CardListGallery(),
  articleMediaImg: new ArticleMediaImg(),
  articleMediaSlider: new ArticleMediaSlider(),
  articleHeader: new ArticleHeader(),
  articleDescription: new ArticleDescription(),
  articleMediaVideo: new ArticleMediaVideo(),
  articleSocial: new ArticleSocial(),
  scrollIcon: new ScrollIcon(),
  articleAttachments: new ArticleAttachments(),
};

const PageInstance = new Page(); // must be initialized after the other components

export {
  PageInstance,
  Components,
  PageData,
  Cookies,
  Keyboard,
  Logger,
  Responsive,
};
